/** @type {import("vuex").ActionTree} */
export const actions = {};

export default actions;
